import { render, staticRenderFns } from "./EditQuestionImage.vue?vue&type=template&id=4124cc49&"
import script from "./EditQuestionImage.vue?vue&type=script&lang=js&"
export * from "./EditQuestionImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports